import { FeatureParams, SubFeatures, GetValues, FeatureKey } from "./common";

export type SocialSubFeatures = {
  zceppa_template: "zceppa_template";
  custom_template: "custom_template";
  categories: "categories";
  background_type: "background_type";
  share_to_customers: "share_to_customers";
  post_analytics: "post_analytics";
  multi_outlet_share: "multi_outlet_share";
  social_download_report: "social_download_report";
  social_widget: "social_widget";
  social_review_share: "social_review_share";
  social_review_share_value: "social_review_share_value";
  social_review_share_frequency: "social_review_share_frequency";
};

export const SOCIAL_SUBFEATURES: SocialSubFeatures = {
  zceppa_template: "zceppa_template",
  custom_template: "custom_template",
  categories: "categories",
  background_type: "background_type",
  share_to_customers: "share_to_customers",
  post_analytics: "post_analytics",
  multi_outlet_share: "multi_outlet_share",
  social_download_report: "social_download_report",
  social_widget: "social_widget",
  social_review_share: "social_review_share",
  social_review_share_value: "social_review_share_value",
  social_review_share_frequency: "social_review_share_frequency",
};
interface SocialParams
  extends FeatureParams<"feature_social", GetValues<SocialSubFeatures>> {}
export interface SocialFeatures
  extends SubFeatures<GetValues<SocialSubFeatures>> {}

export interface SocialStructure {
  [key: string]: SocialParams;
}
